import { render, staticRenderFns } from "./PricingTableMenu.vue?vue&type=template&id=09bb520c&"
import script from "./PricingTableMenu.vue?vue&type=script&lang=js&"
export * from "./PricingTableMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports